import { compose, withPropsOnChange } from "recompose"

import { getVisits } from "../../api/entities/visits"
import withApiTransport from "../../api/apiTransport"

const enhance = compose(
  withPropsOnChange([`issue`], ({ issue: { id } = {} }) => ({
    load: getVisits,
    propName: `visits`,
    payload: id,
  })),
  withApiTransport,
)

export default enhance
